var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"btn",class:{'no-select-color':_vm.color === false},on:{"click":_vm.handleSelectCourse}},_vm.attr.click),[_c('div',{staticClass:"btn-name",class:{'btn-handle':_vm.state === true}},[_vm._v(_vm._s(_vm.attr.name))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('audio',{attrs:{"id":"audio"}},[_c('source',{attrs:{"src":require("../../assets/pop.mp3"),"type":"audio/mpeg"}})])
}]

export { render, staticRenderFns }